import React, {useState} from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from '../ModalContentWrapper';
import '../TwoColumnModal.scss';
import './ModalGeneric.scss';

export const ModalGenericModes = {
    COMPLETE: 'complete',
}

const SaveButton = ({state, onClick, children}) =>
{
    const clickHandler = state === '' ? onClick : null;

    return (
        <button onClick={clickHandler} style={{marginLeft: '10px'}} disabled={state}
                className='btn btn-icon btn-primary btn-icon-right btn-small'>{children}<i className="et-save"/>
        </button>
    )
}

const ModalGeneric = ({ child_id, cap_id, onSaveCompleted, onClose, mode, width, transferData }) =>
{
    const [buttonState, setButtonState] = useState('');

    const onSaveComplete = ( result ) =>
    {
        onSaveCompleted( result );
    }

    const onClickCancel = () =>
    {
        onClose();
    }

    const doSave = (data) =>
    {
        switch ( mode )
        {
            case ModalGenericModes.COMPLETE:
                onSaveCompleted( 'complete' );
            break;

            default:
                throw new Error ("Invalid mode passed to ModalDelegatePep") ;
        }
    }

    const disableButtons = () =>
    {
        setButtonState('disabled');
    }

    const getSaveButtonText = () =>
    {
        const saveButtonText = {
            [ModalGenericModes.COMPLETE]: 'Ok',
        };

        return saveButtonText[mode];
    }

    const onClickSaveForm = (status) =>
    {
        doSave(null);
    }

    const formContent = () =>
    {
        return <div className="modal-button-row">
            <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i
                className="et-arrow-bold-left"/></button>
            <SaveButton state={buttonState} onClick={onClickSaveForm}>
                {getSaveButtonText(mode)}
            </SaveButton>
        </div>
    }

    const title = () =>
    {
        const headerStyle = {marginBottom: '10px'};

        switch ( mode )
        {
            case ModalGenericModes.COMPLETE:
                return <h3 style={headerStyle}>Operation Complete</h3>
        }
    }

    return (
        <ModalContentWrapper className="modal-delegate-pep" width={'600px'} columns={1}>
            {title()}
            {formContent()}
        </ModalContentWrapper>
    )
}

export default ModalGeneric;

ModalGeneric.propTypes = {
    pep_id: PropTypes.string,
    section: PropTypes.string,
    mode: PropTypes.oneOf([ModalGenericModes.CREATE, ModalGenericModes.EDIT, ModalGenericModes.DELETE]),
};